import React from 'react';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';

export default function index(props) {
  return <Tnc {...props} isFixed />;
}
